import React from "react";
import { Form, Input, Checkbox } from "antd";
import { sportsTherapyOptions } from "../../../../IpEMR/Options/physioOptions";
import DeselectableRadioGroup from "../../../../../blocks/FormItems/DeselectableRadioGroup";
import DynamicInputFields from "../../../../../blocks/FormItems/DynamicInputFields";

const SportsTherapy = ({ onValuesChange, formData }) => {
  const [form] = Form.useForm();
  const selectedTherapy = Form.useWatch("others", form);
      const showOthers = selectedTherapy ?? false;
  return (
    <Form
      id="sports-form"
      form={form}
      onValuesChange={(cur, all) => onValuesChange("therapy", all)}
      layout="vertical"
      className="ip-forms"
      initialValues={formData?.therapy}
    >
      {sportsTherapyOptions?.map((subOption) => (
        <DeselectableRadioGroup
          name={subOption?.name_key}
          label={subOption?.label}
          options={subOption?.options}
          form={form}
        />
      ))}
      <Form.Item name={"postural_correction"}label={"Postural Correction"}>
        <Input.TextArea
          rows={2}
          placeholder="Postural Correction"
          style={{ width: "60%" }}
        />
      </Form.Item>
      <Form.Item name={"therapy_comments"} label={"Comments"}>
        <Input.TextArea
          rows={2}
          placeholder="Comments"
          style={{ width: "60%" }}
        />
      </Form.Item>
      <Form.Item name={"others"} valuePropName="checked">
                <Checkbox>Others</Checkbox>
              </Form.Item>
              {showOthers && (
                <DynamicInputFields
                  field_key={"others"}
                  form={form}
                  inputStyle={{ maxWidth: 800 }}
                />
              )}
    </Form>
  );
};

export default SportsTherapy;
